

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('PrivacyPolicyCtrl', function ($scope,$rootScope) {
$rootScope.title='Terms and Conditions';


});

